import Keycloak from "keycloak-js";

const keycloak = new Keycloak({
  clientId: "upgrade-api-client",
  realm: "upgrade-dev-realm",
  url: process.env.REACT_APP_KEYCLOAK_URL,
});

export default keycloak;